<template>
  <div class="app-container">
    <div class="title">
      <span v-html="$t('message.tasas.titulo' + tipoEmpresa)"></span>
    </div>
    <v-form ref="formDeclaracion" lazy-validation>
      <Divider>{{ $t('message.tasas.apartado1') }}</Divider>
      <v-container fluid grid-list-xs>
        <v-layout d-inline-flex>
          <v-flex xs6>
            <v-text-field
              :label="$t('message.comun.mesDeclaracion')"
              v-model="form.mesDeclaracion"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              :label="$t('message.comun.mesFacturacion')"
              v-model="form.mesFacturacion"
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-layout v-if="form.mesFacturacion">
        <v-flex lg6>
          <Divider>{{ $t('message.tasas.apartado5') }}</Divider>
          <v-container fluid grid-list-lg>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg4>
                <v-text-field
                  :label="$t('message.comun.nif')"
                  v-model="userNIFCIF"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg6>
                <v-text-field
                  :label="$t('message.comun.nombre')"
                  v-model="userName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg10>
                <v-text-field
                  :label="$t('message.comun.fecha')"
                  v-model="fechaActual"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex lg6>
          <Divider>{{ $t('message.tasas.apartado6') }}</Divider>
          <v-container fluid grid-list-lg>
            <v-layout wrap>
              <v-flex lg12>
                {{
                  $t('message.comun.consultaingreso', {
                    tipo: $tc('message.home.menu.tasas.titulo', 2)
                  }) +
                    ' ' +
                    $t('message.comun.justificante.numeroValor', { valor: modelo.nujustas })
                }}
              </v-flex>
              <v-flex xs8 sm6 md4 lg4>
                <Numeric
                  id="importeAIngresar"
                  :label="$t('message.comun.importeTotal')"
                  :value="form.cuotaTributariaTotal"
                  currency="€"
                  readonly
                ></Numeric>
              </v-flex>
              <v-flex lg12>
                <v-text-field
                  :mask="maskIBAN"
                  v-model="form.numCuenta"
                  :label="$t('message.comun.cuenta')"
                  :placeholder="maskIBAN"
                  :rules="rules.numCuenta"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex text-xs-center>
          <Boton
            id="btnPresentar"
            :onclick="onSubmit"
            v-if="form.mesFacturacion"
            :deshabilitado="puedePresentar"
            >{{ $t('message.tasas.consultarTasa') }}</Boton
          >
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { TASA_TARIFA, TASA_PEAJE, TIPO_DECLARACION_TASA, tasaConst } from './constTasas';
import { Divider, Modal, Numeric, Boton } from '@/components';
import redirect from '@/router/redirect';
import { mapActions, mapGetters } from 'vuex';
import { getVigenciaCuotaEmpresa } from '@/api/empresas';
import { empConst } from '@/utils/constants';
import { getPagosDeTasas } from '@/api/declaraciones';
import moment from 'moment';

export default {
  name: 'consultatasa',
  props: {
    modelo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        idEmpresa: null,
        tipoDeclaracion: TIPO_DECLARACION_TASA,
        mesDeclaracion: null,
        mesFacturacion: null,
        numCuenta: '',
        cuotaTributariaTotal: this.modelo.nueurtot,
        formaPago: 'E',
        url: ''
      },
      maskIBAN: 'ES## - #### - #### - ## - ##########',
      rules: {
        numCuenta: [
          v => !!v || 'Campo obligatorio',
          v =>
            (v && v.length == 24) ||
            'Debe indicar el código IBAN junto a los 20 dígitos de la cuenta bancaria'
        ]
      }
    };
  },
  components: {
    Divider,
    Modal,
    Numeric,
    Boton
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Tasas', to: '/tasas', disabled: false },
        { text: 'Consulta Pagos de Tasas', to: '/tasas/consulta-pagos', disabled: true }
      ],
      menuSelected: '/tasas/presentacion-tasa'
    });
    // Se verifica que pueda acceder
    this.checkIntegrity();

    // Se cargar datos iniciales
    this.cargarDatos();
  },
  computed: {
    ...mapGetters(['empresaSelected', 'userNIFCIF', 'userName']),
    tipoEmpresa() {
      return this.empresaSelected.cdtipemp;
    },
    tipoMensaje() {
      return this.empresaSelected.cdtipemp === 'E' ? 1 : 2;
    },
    idCurrentTasa() {
      return this.tipoEmpresa === empConst.TIPO_GAS
        ? tasaConst.ID_TASA_GAS
        : this.tipoEmpresa === empConst.TIPO_ELE
        ? tasaConst.ID_TASA_ELE
        : tasaConst.ID_TASA_PET;
    },
    fechaActual() {
      return moment().format('DD [de] MMMM [de] YYYY');
    },
    allowEdit() {
      return false;
    },
    tarifas() {
      return this.tarifasPeajes.filter(
        item => item.tipoEmpresa === this.tipoEmpresa && item.tipoTasa === TASA_TARIFA
      );
    },
    peajes() {
      return this.tarifasPeajes.filter(
        item => item.tipoEmpresa === this.tipoEmpresa && item.tipoTasa === TASA_PEAJE
      );
    }
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    checkIntegrity() {
      if (
        this.tipoEmpresa !== empConst.TIPO_GAS &&
        this.tipoEmpresa !== empConst.TIPO_ELE &&
        this.tipoEmpresa !== empConst.TIPO_PET
      ) {
        redirect.toError('Tipo de empresa no permitido');
      }
    },
    cargarDatos() {
      this.setLoading(true);
      // Preparamos el payload
      let payload = {
        idEmpresa: this.empresaSelected.idempres,
        idCuota: this.idCurrentTasa
      };
      getVigenciaCuotaEmpresa(payload)
        .catch(error => {
          if (error.response && error.response.status === 404) {
            redirect.toError(new Error('A esta empresa no se le aplica esta tasa'));
          } else {
            redirect.toError(error);
          }
        })
        .then(() => {
          // Cargamos datos inciales
          if (!this.form) {
            this.$router.push({ name: 'pagotasas' });
          } else {
            this.form.idEmpresa = this.empresaSelected.idempres;
            this.form.mesDeclaracion = this.modelo.fefinfacPublic;
            this.form.mesFacturacion = this.modelo.fepresenPublic;
          }
          this.setLoading(false);
        });
      getPagosDeTasas(this.modelo.nujustas)
        .catch(error => {
          if (error.response && error.response.status === 404) {
            redirect.toError(new Error('A esta empresa no se le aplica esta tasa'));
          } else {
            redirect.toError(error);
          }
        })
        .then(response => {
          // Cargamos datos inciales
          this.form.url = response.data.url;
          this.setLoading(false);
        });
    },
    onSubmit() {
      // Validar formulario
      this.setLoading(true);
      if (this.$refs.formDeclaracion.validate()) {
        let urlOut = this.form.url;
        [
          '02',
          String(Math.round10(Math.round10(this.form.cuotaTributariaTotal, -2) * 100, 0)),
          this.modelo.nujustas,
          this.form.numCuenta,
          window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.hostname === 'localhost' ? ':8443' : ''),
          btoa(this.form.idEmpresa + ';' + this.tipoEmpresa + ';' + this.form.cuotaTributariaTotal)
        ].forEach((item, index) => {
          urlOut = urlOut.replace('{' + index + '}', item);
        });
        window.open(urlOut, '_self');
      }
      this.setLoading(false);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.title {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  min-height: 90px;

  img.left {
    float: left;
    width: 90px;
  }

  img.right {
    float: right;
    width: 190px;
  }
}

.v-form > .container > .layout > .flex {
  padding: 8px;
}

.ayuda {
  margin: 0px;
  font-size: 0.875rem;
  font-weight: bold;
  width: 100%;
}
</style>
